module.exports = __webpack_public_path__ + "img/Visa.fd2413fa.svg";